<template>
  <div>
    <!-- :btnCreate="true" -->
    <PageTitle
      title="Cheques"
      :btnCreate="true"
      :createPopup="true"
      @onClickCreate="createCheque()"
      :permission="'Cheques Index'"
    />

    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-flex>
        <v-row>
          <!-- Cheques to pay Component Card -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pb-2 px-1 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="background-color: rgb(255, 162, 0, 1)"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>Cheques to pay({{ ToPay[0] }})</div>
                  </div>
                </v-col>

                <!-- <v-col
                  cols="3"
                  lg="3"
                  sm="2"
                  md="3"
                  class="text-lg-center font-weight-bold"
                >
                  <div class="topCard">
                    {{ ToPay[0] }}
                  </div>
                </v-col> -->
                <v-col cols="6" class="text-lg-right font-weight-bold pr-5">
                  <div class="topCard text-right">
                    {{ ToPay[1] | formatCurrency }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- Cheques to receive Component Card -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pb-2 px-1 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0"
              width="100%"
              style="background-color: rgb(0, 170, 16, 1)"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>Cheques to receive({{ ToReceive[0] }})</div>
                  </div>
                </v-col>

                <!-- <v-col
                  cols="3"
                  lg="3"
                  sm="2"
                  md="3"
                  class="text-lg-center font-weight-bold"
                >
                  <div class="topCard">
                    {{ ToReceive[0] }}
                  </div>
                </v-col> -->
                <v-col cols="6" class="text-lg-right font-weight-bold pr-5">
                  <div class="topCard text-right">
                    {{ ToReceive[1] | formatCurrency }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- Cancelled Cheques Component Card -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pb-2 px-1 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0"
              width="100%"
              style="background-color: rgb(201, 76, 76, 1)"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>Cancelled Cheques({{ Cancelled[0] }})</div>
                  </div>
                </v-col>

                <!-- <v-col
                  cols="3"
                  lg="3"
                  sm="2"
                  md="3"
                  class="text-lg-center font-weight-bold"
                >
                  <div class="topCard">
                    {{ Cancelled[0] }}
                  </div>
                </v-col> -->
                <v-col cols="6" class="text-lg-right font-weight-bold pr-5">
                  <div class="topCard text-right">
                    {{ Cancelled[1] | formatCurrency }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- total Cheque Amount -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pb-2 px-1 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0"
              width="100%"
              style="background-color: rgb(87, 87, 87, 1)"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>Total Cheque Amount</div>
                  </div>
                </v-col>
                <v-col cols="6" class="text-lg-right font-weight-bold pr-5">
                  <div class="topCard text-right">
                    {{ total | formatCurrency }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter-outline' : 'mdi-filter' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content py-0" v-show="!show">
          <TableFilters
            :filters="['cheqStatus', 'search', 'dateRange', 'cheqFor']"
            v-model="filter"
            :columns="columns"
            :msgs="'Cheque No'"
          ></TableFilters>
        </v-card>
      </v-expand-transition>
      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12 px-2 pt-0">
          <ValidationObserver ref="observer">
            <v-row>
              <v-card-text class="pa-0">
                <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :headers="headers"
                  :items="ChequeList"
                  class="row-pointer"
                  hide-default-footer
                  item-class="test2"
                  style="font-family: 'Source Sans Pro', sans-serif"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        @click="viewCheque(item.id)"
                        :class="
                          getDateValidation(item.date) &&
                          item.chequeFor === 'purchase' &&
                          item.status == 'Pending'
                            ? 'custom-highlight-row'
                            : ''
                        "
                        v-for="(item, key) in items"
                        :key="item.name"
                      >
                        <td style="width: 14%">
                          <div>{{ item.date_time | formatDate }}</div>
                        </td>
                        <td style="width: 14%">
                          <div>{{ item.number }}</div>
                        </td>
                        <td style="width: 14%">
                          <div>{{ item.date | formatDate }}</div>
                        </td>
                        <td style="width: 14%">
                          <div>{{ item.bank }}</div>
                        </td>
                        <td style="width: 14%">
                          <div>{{ item.amount | formatCurrency }}</div>
                        </td>
                        <td
                          style="width: 14%"
                          :class="item.chequeFor === 'other' ? 'other' : ''"
                        >
                          <div>{{ item.chequeFor }}</div>
                        </td>
                        <td style="width: 14%">
                          <div>{{ item.supplier ? item.supplier : '---' }}</div>
                        </td>
                        <td style="width: 14%">
                          <v-chip
                            :x-small="true"
                            class="ma-2"
                            label
                            text-color="white"
                            :color="getStatusColor(item.status)"
                            dark
                          >
                            <div>{{ item.status }}</div>
                          </v-chip>
                        </td>
                        <!-- <td style="width:14%">
                          <list-menu
                            v-if="item.status == 'Pending'"
                            feature="cheque"
                            :item="item"
                            editPermission="Cheques Index"
                            @refreshList="refreshData"
                            @onEditClicked="editCheque(item)"
                            :isEditModal="true"
                          ></list-menu>
                        </td> -->
                      </tr>
                    </tbody>
                  </template>

                  <!--
                        <template slot="body.append" >
                                        <tr class="black--text">
                                          <th class="title"></th>
                                          <th class="title"></th>
                                          <th class="title"></th>


                                          <th>
                                            <h3 class="justify-content-end pl-2">
                                         {{ total | formatCurrency }}
                                            </h3>
                                          </th>

                                          <th class="title"></th>

                                          <th class="title"></th>
                                          <th class="title"></th>
                                        </tr>
                                      </template> -->

                  <template v-slot:no-data>
                    <div class="mt-16 container justify-center item-center">
                      <noData name="Order" />
                    </div>
                  </template>
                  <template v-slot:item.reference_number="{ item }">
                    <CopyTableCell
                      :text="item.reference_number"
                    ></CopyTableCell>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.status)"
                      dark
                      >{{ item.status }}</v-chip
                    >
                  </template>
                  <!--
                                    <template style="background:red" v-slot:item.date="{ item }">
                                      {{ item.date | formatDate }}
                                    </template> -->
                  <!-- <template v-slot:item.action="{ item }">
                    <list-menu
                      v-if="item.status == 'Pending'"
                      feature="cheque"
                      :item="item"
                      editPermission="Cheques Index"
                      @refreshList="refreshData"
                      @onEditClicked="editCheque(item)"
                      :isEditModal="true"
                    ></list-menu>
                  </template> -->
                  <template v-slot:footer>
                    <pagination
                      @paginationOptions="setPaginationOptions"
                      @response="receiveChequeData"
                      @getPageNumber="setPagenumber"
                      url="cheques"
                      :filterAction="true"
                      :filter="filter"
                      ref="pagination"
                    />
                  </template>
                </v-data-table>
              </v-card-text>
            </v-row>
          </ValidationObserver>
        </v-container>
      </v-card>
    </v-container>

    <ChequeDetails ref="refChequeDetails" @onClose="onClose" />
    <ChequeCreate
      @conform="conform()"
      @afterSave="refreshData()"
      ref="refCreateCheque"
    />

    <ChequeEdit
      @close="AddWarehouse($event)"
      @conform="conform()"
      @afterSave="refreshData()"
      ref="refEditCheque"
    />
  </div>
</template>
<script>
import noData from '@/components/shared/noItem';
import TableFilters from '@/components/base/TableFilters';
import pagination from '../shared/components/pagination.vue';
import ChequeDetails from './ChequeDetails.vue';
import ChequeCreate from './ChequeCreate.vue';

import ChequeEdit from './ChequeEdit.vue';
import { Cheque } from '../../models/Cheque';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { Product } from '../../models/Product';

export default {
  data: () => ({
    show: 'false',
    paginationOptions: {},
    showChequeCreate: true,
    selectedCheque: null,
    columns: [
      {
        text: 'Create Date',
        value: 'date',
        show: true,
        disabled: false,
        width: '14%',
      },
      {
        text: 'Cheque No',
        value: 'number',
        show: true,
        disabled: true,
        width: '14%',
      },
      {
        text: 'Cheque Date',
        value: 'date_time',
        show: true,
        disabled: true,
        width: '14%',
      },
      {
        text: 'Bank',
        value: 'bank',
        show: true,
        disabled: true,
        width: '14%',
      },
      {
        text: 'Amount',
        value: 'amount',
        show: true,
        disabled: true,
        align: 'left',
        width: '14%',
      },
      {
        text: 'Cheque For',
        value: 'chequeFor',
        show: true,
        disabled: true,
        width: '14%',
      },
      {
        text: 'Beneficiary Name',
        value: 'supplier',
        show: true,
        disabled: true,
        width: '14%',
      },
      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: true,
        width: '14%',
      },
      // {
      //   text: "Action",
      //   value: "action",
      //   show: true,
      //   disabled: true,
      //   align: "center",
      //   width: "14%",
      // },
    ],
    ChequeList: [],
    filter: {
      invoice_status: '',
      cheqStatus: '',
      chequeFor: '',
      start: '',
      end: '',
      amount: '',
      supplier: '',
      search: '',
      status: '',
    },
    showChequeDetails: false,
    pendingCheques: [],
    total: 0,
    Cancelled: [],
    ToPay: [],
    ToReceive: [],
  }),
  components: {
    pagination,
    noData,
    TableFilters,
    ChequeDetails,
    ChequeCreate,
    ChequeEdit,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },

    noOfPayingCheques: function () {
      // return "test"
      return this.pendingCheques.filter((item) => item.chequeFor == 'purchase')
        .length;
    },
    noOfReceivingCheques: function () {
      return this.pendingCheques.filter((item) => item.chequeFor == 'sale')
        .length;
    },

    payingAmount: function () {
      let value = 0;
      this.pendingCheques
        .filter((item) => item.chequeFor == 'purchase')
        .forEach((element) => {
          value += +element.amount;
        });
      return value;
    },
    receivingAmount: function () {
      let value = 0;
      this.pendingCheques
        .filter((item) => item.chequeFor == 'sale')
        .forEach((element) => {
          value += +element.amount;
        });
      return value;
    },
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    async getPendingCheques() {
      await this.$store
        .dispatch('chequeManagement/GetPendingCheques')
        .then((res) => {
          this.pendingCheques = res.data.map((element) => {
            return new Cheque().toViewModel(element);
          });
        })
        .catch((err) => {});
    },
    sumField(array, field) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[field]);
      });
      return value;
    },
    // Cancelled Cheques
    cancelled(array, statusfield, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[statusfield] == 'Canceled') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let cancelledCheque = [value, amount];
      return cancelledCheque;
    },

    // Cheques to pay
    toPay(array, statusfield, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[statusfield] == 'Pending' && element[type] == 'purchase') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let chequesToPay = [value, amount];
      return chequesToPay;
    },

    // Cheques to receive
    toReceive(array, statusfield, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[statusfield] == 'Pending' && element[type] == 'sale') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let chequesToReceive = [value, amount];
      return chequesToReceive;
    },

    onClose() {
      this.getPendingCheques();
      this.$refs.pagination.refreshData();
    },
    receiveChequeData(data) {
      this.ChequeList = data.map((element) => {
        return new Cheque().toViewModel(element);
      });
      this.total = this.sumField(this.ChequeList, 'amount');
      this.Cancelled = this.cancelled(this.ChequeList, 'status', 'amount');
      this.ToPay = this.toPay(this.ChequeList, 'status', 'chequeFor', 'amount');
      this.ToReceive = this.toReceive(
        this.ChequeList,
        'status',
        'chequeFor',
        'amount',
      );
    },
    viewCheque(chequeId) {
      this.$refs.refChequeDetails.openModal(chequeId);
    },
    createCheque() {
      this.$refs.refCreateCheque.openModal();
    },
    editCheque(cheque) {
      this.$refs.refEditCheque.openModal(cheque.id);
    },
    conform() {
      this.$refs.pagination.fetchData();
    },
    getDateValidation(d) {
      var date = new Date(d);
      date.setDate(date.getDate() - 1);

      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      // Add a day
      // date.setDate(date.getDate() + 1)

      let yesterDay = new Date();
      yesterDay.setHours(0);
      yesterDay.setMinutes(0);
      yesterDay.setSeconds(0);

      if (date.getTime() <= yesterDay.getTime()) {
        return true;
      } else {
        return false;
      }
    },

    getStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        case 'Return':
          return '#973a5a';
          break;
        default:
          break;
      }
    },
  },
  created() {
    // this.$refs.refChequeDetails.openModal();
    this.getPendingCheques();
  },
  watch: {},
  filters: {},
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.topCard {
  color: white;
}
.other {
  color: cornflowerblue;
}
.min-button::before {
  display: none;
}
</style>
